import { put, SagaIterator, select, takeEvery } from './core/sagaEffects';
import { Logout, ResetStore } from 'acscp/actions';
import history from 'acscp/store/history';
import { AppState } from 'acscp/store';
import { LocationDescriptor } from 'history';
import { LoginPageVariant } from 'acscp/store/loginPageVariant';
import { defaultLoginUrlForVariant } from 'acscp/components/routeHelper';

export function loginPageVariantSelector(state: AppState): LocationDescriptor {
    return state.auth.loginPageVariant || LoginPageVariant.JetPortal;
}

export function* logoutSaga(): SagaIterator {
    yield takeEvery(Logout, logout);
}

function* logout(): SagaIterator {
    const loginPageVariant = (yield select(loginPageVariantSelector)) as unknown as LoginPageVariant;

    yield put(new ResetStore());

    history.push(defaultLoginUrlForVariant(loginPageVariant));
}
